function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var assert = require("assert");

import _ from "lodash";
import { DecisionNode } from "./DecisionNode";
import { Stack } from "./Stack";
export var DecisionTree = /*#__PURE__*/function () {
  function DecisionTree(topLevelObj) {
    _classCallCheck(this, DecisionTree);

    this._headNode = null;
    this._currentNode = null;
    this._allNodes = [];
    this._backSteps = new Stack();
    this._fwdSteps = new Stack();
    this.sourceFile = null;
    var dec = topLevelObj["decisions"];

    for (var subObjIndex = 0; subObjIndex < dec.length; subObjIndex++) {
      var subLevelObj = dec[subObjIndex];
      var newNode = new DecisionNode(subLevelObj); //if (_.isEmpty(newNode.parentVariables)) {
      //    assert(this._headNode == null, 'multiple head nodes found!');
      //    this._headNode = newNode;
      //}

      this._allNodes.push(newNode);
    } // this function now has to also identify the head node!


    this._connectNodesToParents();

    assert(this._headNode != null, "no head node found!");
    this._currentNode = this._headNode;
    this.sourceFile = _.get(topLevelObj, "sourceFile", "");
  }

  _createClass(DecisionTree, [{
    key: "_connectNodesToParents",
    value: function _connectNodesToParents() {
      var nodesWithNoParent = _.clone(this._allNodes);

      for (var i = 0; i < this._allNodes.length; i++) {
        var node = this._allNodes[i]; //if (node == this._headNode) {
        //    continue;
        //}

        for (var j = 0; j < this._allNodes.length; j++) {
          var potentialParentNode = this._allNodes[j];

          if (node == potentialParentNode) {
            continue;
          }

          if (potentialParentNode.isAValidParentTo(node)) {
            //console.log('Identified Node ' + potentialParentNode.description + ' as parent of Node ' + node.description);
            node.setParentNode(potentialParentNode);
            potentialParentNode.addChildNode(node);

            _.remove(nodesWithNoParent, function (n) {
              return n == node;
            });
          }
        }
      }

      assert(nodesWithNoParent.length == 1, "ERROR: Found " + nodesWithNoParent.length + " head nodes!");
      this._headNode = nodesWithNoParent[0];

      this._headNode.rebuildParentVariablesInChildNodes();
    }
  }, {
    key: "peekNextStepBack",
    value: function peekNextStepBack() {
      if (this._backSteps.empty()) {
        return null;
      } else {
        return this._backSteps.peek();
      }
    }
  }, {
    key: "peekNextStepFwd",
    value: function peekNextStepFwd() {
      if (this._fwdSteps.empty()) {
        return null;
      } else {
        return this._fwdSteps.peek();
      }
    }
  }, {
    key: "moveToNode",
    value: function moveToNode(child) {
      this._backSteps.push(this._currentNode);

      this._currentNode = child; // Clear forwards history unless the requested node is along the history

      if (!this._fwdSteps.empty() && this._fwdSteps.peek() == child) {
        this._fwdSteps.pop();
      } else {
        this._fwdSteps.clear();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      assert(!this._backSteps.empty());

      this._fwdSteps.push(this._currentNode);

      this._currentNode = this._backSteps.pop();
    }
  }, {
    key: "stepFwd",
    value: function stepFwd() {
      assert(!this._fwdSteps.empty());

      this._backSteps.push(this._currentNode);

      this._currentNode = this._fwdSteps.pop();
    }
  }, {
    key: "decisionHistory",
    value: function decisionHistory() {
      var list = []; // traverse the backwards history stack by pushing it to a temporary stack

      var tempStack = new Stack();

      while (!this._backSteps.empty()) {
        tempStack.push(this._backSteps.pop());
      }

      while (!tempStack.empty()) {
        var node = tempStack.pop();
        list.push(node);

        this._backSteps.push(node);
      }

      if (this._currentNode != null) {
        list.push(this._currentNode);
      }

      return list;
    }
  }, {
    key: "getHeadNode",
    value: function getHeadNode() {
      return this._headNode;
    }
  }, {
    key: "getCurrentNode",
    value: function getCurrentNode() {
      return this._currentNode;
    }
  }, {
    key: "getChildForSetOfVariables",
    value: function getChildForSetOfVariables(variables) {
      return this._currentNode.getChildForSetOfVariables(variables);
    }
  }, {
    key: "getLogsForSetOfVariables",
    value: function getLogsForSetOfVariables(variables) {
      return this._currentNode.getLogsForSetOfVariables(variables);
    }
  }, {
    key: "getTrajectoriesForSetOfVariables",
    value: function getTrajectoriesForSetOfVariables(variables) {
      return this._currentNode.getTrajectoriesForSetOfVariables(variables);
    }
  }, {
    key: "getSegmentLengthForSetOfVariables",
    value: function getSegmentLengthForSetOfVariables(variables) {
      return this._currentNode.getSegmentLengthForSetOfVariables(variables);
    }
  }, {
    key: "getCurrentControlPointPosition",
    value: function getCurrentControlPointPosition() {
      return this._currentNode.getMDposition();
    }
  }, {
    key: "getGridPointersForSetOfVariables",
    value: function getGridPointersForSetOfVariables(variables) {
      return this._currentNode.getGridsForSetOfVariables(variables);
    }
  }]);

  return DecisionTree;
}();